module.exports = __webpack_public_path__ + "assets/b11732514749fe36184c6bb1d801ec6b.png";